import { confirmToast } from "../../utils/toast";
import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";

const UserMaster = () => {
  const initialForm = {
    UserName: "",
    UserFullName: "",
    UserPWD: "",
    Type_Id: "",
    InTime: "",
    OutTime: "",
    IsActive: true,
    RestrictIP: false,
    Remark: "",
  };

  const [activeTab, setActiveTab] = useState("list");
  const [form, setForm] = useState(initialForm);
  const [userTypes, setUserTypes] = useState([]);
  const [users, setUsers] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;

  useEffect(() => {
    fetchUserTypes();
    fetchUsers();
  }, []);

  const fetchUserTypes = async () => {
    try {
      const res = await axios.get("/user-types");
      setUserTypes(res.data);
    } catch (err) {
      console.error("Error loading user types:", err);
      setUserTypes([]);
    }
  };

  const fetchUsers = async () => {
    const res = await axios.get("/users");
    setUsers(res.data);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const resetForm = () => {
    setForm(initialForm);
    setEditingId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.UserName || !form.UserPWD || !form.Type_Id) {
      alert("User Name, Password and User Type are required.");
      return;
    }

    const payload = {
      ...form,
      Type_Id: parseInt(form.Type_Id, 10),
    };

    try {
      if (editingId) {
        await axios.put(`${"/users"}/${editingId}`, payload);
      } else {
        await axios.post("/users", payload);
      }

      alert(editingId ? "User updated successfully" : "User saved successfully");
      fetchUsers();
      resetForm();
      setActiveTab("list");
    } catch (err) {
      alert(err.response?.data?.message || "Error saving user");
    }
  };

  const handleEdit = (u) => {
    setForm({
      UserName: u.UserName || "",
      UserFullName: u.UserFullName || "",
      UserPWD: "",
      Type_Id: u.Type_Id?.toString() || "",
      InTime: u.InTime || "",
      OutTime: u.OutTime || "",
      IsActive: !!u.IsActive,
      RestrictIP: !!u.RestrictIP,
      Remark: u.Remark || "",
    });

    setEditingId(u.UserID);
    setActiveTab("form");
  };

  const handleDelete = async (u) => {
    if (!await confirmToast("Delete this user?")) return;
    await axios.delete(`${"/users"}/${u.UserID}`);
    fetchUsers();
  };

  // Search filter
  const filteredUsers = users.filter((u) =>
    (u.UserName || "").toLowerCase().includes(search.toLowerCase()) ||
    (u.UserFullName || "").toLowerCase().includes(search.toLowerCase()) ||
    (u.UserTypeName || "").toLowerCase().includes(search.toLowerCase())
  );

  // Pagination
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentData = filteredUsers.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);

  return (
    <div className="container mt-3">

      <div className="mb-3">
        <h4 className="fw-bold">👤 User Master</h4>
      </div>

      <div className="card shadow-sm border-0">

        {/* Tabs */}
        <div className="card-header bg-white">
          <ul className="nav nav-tabs card-header-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "list" ? "active" : ""}`}
                onClick={() => setActiveTab("list")}
              >
                User List
              </button>
            </li>

            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "form" ? "active" : ""}`}
                onClick={() => {
                  resetForm();
                  fetchUserTypes();
                  setActiveTab("form");
                }}
              >
                {editingId ? "Edit User" : "Add User"}
              </button>
            </li>
          </ul>
        </div>

        <div className="card-body">

          {/* ================= LIST TAB ================= */}
          {activeTab === "list" && (
            <>
              <div className="d-flex justify-content-between mb-3">
                <input
                  className="form-control w-50"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>User Name</th>
                      <th>Full Name</th>
                      <th>User Type</th>
                      <th>In / Out</th>
                      <th>Active</th>
                      <th>Restrict IP</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.map((u) => (
                      <tr key={u.UserID}>
                        <td>{u.UserName}</td>
                        <td>{u.UserFullName}</td>
                        <td>{u.UserTypeName}</td>
                        <td>{u.InTime} - {u.OutTime}</td>
                        <td>{u.IsActive ? "Yes" : "No"}</td>
                        <td>{u.RestrictIP ? "Yes" : "No"}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => handleEdit(u)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDelete(u)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Showing {indexOfFirst + 1} to{" "}
                    {Math.min(indexOfLast, filteredUsers.length)} of{" "}
                    {filteredUsers.length} entries
                  </div>

                  <ul className="pagination mb-0">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link"
                        onClick={() => setCurrentPage(currentPage - 1)}>
                        Previous
                      </button>
                    </li>

                    {[...Array(totalPages)].map((_, index) => (
                      <li key={index}
                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                        <button className="page-link"
                          onClick={() => setCurrentPage(index + 1)}>
                          {index + 1}
                        </button>
                      </li>
                    ))}

                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link"
                        onClick={() => setCurrentPage(currentPage + 1)}>
                        Next
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </>
          )}

          {/* ================= FORM TAB ================= */}
          {activeTab === "form" && (
            <form onSubmit={handleSubmit}>
              <div className="row g-3">

                <div className="col-md-4">
                  <label className="form-label fw-semibold">User Name *</label>
                  <input
                    name="UserName"
                    value={form.UserName}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">Full Name</label>
                  <input
                    name="UserFullName"
                    value={form.UserFullName}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">Password *</label>
                  <input
                    type="password"
                    name="UserPWD"
                    value={form.UserPWD}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">User Type *</label>
                  <select
                    name="Type_Id"
                    value={form.Type_Id}
                    onChange={handleChange}
                    className="form-select"
                    required
                  >
                    <option value="">-- Select Type --</option>
                    {userTypes.map((t) => (
                      <option key={t.UserTypeID} value={t.UserTypeID}>
                        {t.UserTypeName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">In Time</label>
                  <input
                    name="InTime"
                    value={form.InTime}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">Out Time</label>
                  <input
                    name="OutTime"
                    value={form.OutTime}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                <div className="col-md-3">
                  <div className="form-check mt-4">
                    <input
                      type="checkbox"
                      name="IsActive"
                      checked={form.IsActive}
                      onChange={handleChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label">
                      User Active
                    </label>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-check mt-4">
                    <input
                      type="checkbox"
                      name="RestrictIP"
                      checked={form.RestrictIP}
                      onChange={handleChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label">
                      Restrict IP
                    </label>
                  </div>
                </div>

                <div className="col-md-12">
                  <label className="form-label fw-semibold">Remark</label>
                  <textarea
                    name="Remark"
                    value={form.Remark}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

              </div>

              <div className="mt-4 text-end">
                <button type="submit" className="btn btn-success me-2">
                  {editingId ? "Update" : "Save"}
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setActiveTab("list")}
                >
                  Back to List
                </button>
              </div>
            </form>
          )}

        </div>
      </div>
    </div>
  );
};

export default UserMaster;
